import * as React from 'react';
import { BaseRouteProps } from '../../interfaces';
import { User, Survey } from '../../models';
import { SurveyDataService, UserDataService } from '../../services';
import { NavLink } from 'react-router-dom';
import { PVAPage } from '..';

interface SurveyVersionCreateState {
    users: User[];
    surveys: Survey[];
}

export class SurveyVersionCreate extends React.Component<BaseRouteProps<{}>, SurveyVersionCreateState> {
    private surveyDataService = new SurveyDataService(this.props.notificationService);
    private userDataService = new UserDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{}>) {
        super(props);

        this.state = {
            users: new Array<User>(),
            surveys: new Array<Survey>(),
        };

        this.save = this.save.bind(this);
    }

    public componentDidMount() {
        this.userDataService.getAll().then((users: User[]) => {
            this.setState({ users: users });
        });

        this.surveyDataService.getAll().then((surveys: Survey[]) => {
            this.setState({ surveys: surveys });
        });
    }

    public render() {
        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Buttons>
                        <NavLink to={'/surveyversion'}>
                            <span className="glyphicon glyphicon-arrow-left" />
                        </NavLink>
                    </PVAPage.Header.Buttons>
                    <div className="title">Create Survey Version</div>
                </PVAPage.Header>

                <PVAPage.Body>
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }

    private save(values: any) {
        // const survey = this.state.surveys.find(survey => {
        //     return survey.id === values.surveyId;
        // });

        // const user = this.state.users.find(user => {
        //     return user.id === values.userId;
        // });

        // if (survey && user) {

        //     this.surveyVersionDataService.getActive(survey).then((surveyVersion : SurveyVersion) => {

        //         const newSurveyInstance = new SurveyInstance(user, surveyVersion);
        //         this.surveyInstanceDataService.create(newSurveyInstance).then((success) => {
        //             this.props.history.push('/surveyinstance');
        //         });
        //     });
        // }
    }
}


// WEBPACK FOOTER //
// ./src/components/surveyversion/SurveyVersionCreate.tsx